import React from 'react'

import dayjs from 'dayjs'

import phoneIcon from '../images/icon_phone.svg'
import './index.scss'

export function AppointmentDate({ appointmentAt }: { appointmentAt: Date | undefined }) {
  if (appointmentAt == null) {
    return null
  }
  return (
    <div className='modern-chat-appointment-date__wrapper'>
      <img className='modern-chat-appointment-date__icon' src={phoneIcon} alt='Telefontermin' />
      <strong>Telefontermin</strong>&nbsp;{dayjs(appointmentAt).format('DD.MM.YYYY, HH:mm')} Uhr
    </div>
  )
}
